import React from 'react';
import { SettingsNavHeader, SettingsNavOption } from '@/components/common/residents/mobile/SettingsNavHeader';
import { LINKED_ACCOUNTS_COLORS } from '@/constants/residents/mobile/linkedAccountsColors';
import { linkedAccountsStrings, invitationsStrings } from '@/constants/residents/strings';

export type TabType = 'linkedAccounts' | 'invitations';

const TAB_OPTIONS: SettingsNavOption<TabType>[] = [
  {
    key: 'linkedAccounts',
    title: linkedAccountsStrings.cardTitle,
    description: linkedAccountsStrings.navHeader.linkedAccountsDescription,
    activeColor: LINKED_ACCOUNTS_COLORS.navHeaderBackground, // Blue
  },
  {
    key: 'invitations',
    title: invitationsStrings.title,
    description: linkedAccountsStrings.navHeader.invitationsDescription,
    activeColor: LINKED_ACCOUNTS_COLORS.navHeaderInvitationsBackground, // Purple
  },
];

interface LinkedAccountsNavHeaderProps {
  selectedTab: TabType;
  onTabChange: (tab: TabType) => void;
}

/**
 * Mobile Settings Nav Header for Linked Accounts
 * Expandable accordion with tabs for Linked Accounts and Invitations
 * Uses the reusable SettingsNavHeader component
 */
export const LinkedAccountsNavHeader: React.FC<LinkedAccountsNavHeaderProps> = ({
  selectedTab,
  onTabChange,
}) => {
  return (
    <SettingsNavHeader
      options={TAB_OPTIONS}
      selectedKey={selectedTab}
      onSelect={onTabChange}
      activeColor={LINKED_ACCOUNTS_COLORS.navHeaderBackground}
      cardBackgroundColor={LINKED_ACCOUNTS_COLORS.cardBackground}
      textPrimaryColor={LINKED_ACCOUNTS_COLORS.textPrimary}
      textMutedColor={LINKED_ACCOUNTS_COLORS.textMuted}
    />
  );
};

export default LinkedAccountsNavHeader;
